// extracted by mini-css-extract-plugin
export var subtitle = "_cl-2";
export var title = "_cl-0";
export var titleNoWrap = "_cl-1";